"use strict";

exports.__esModule = true;
exports.applySort = applySort;
exports.applySortToValues = applySortToValues;
var _Utils = require("../../../Utils");
/* eslint-disable no-nested-ternary */

var sortValue = function sortValue(a, b) {
  if (a === null) {
    return 1;
  }
  if (b === null) {
    return -1;
  }
  var lowerCaseAText = (0, _Utils.getLowerCaseText)(a);
  var lowerCaseBText = (0, _Utils.getLowerCaseText)(b);
  if (lowerCaseAText === lowerCaseBText) {
    return 0;
  }
  return lowerCaseAText > lowerCaseBText ? 1 : -1;
};
function applySort(data, sortProp, sortOrder) {
  var toSort = data.slice();
  switch (sortOrder) {
    case "asc":
      return toSort.sort(function (a, b) {
        var aValue = a[sortProp];
        var bValue = b[sortProp];
        return sortValue(aValue, bValue);
      });
    case "desc":
      return toSort.sort(function (a, b) {
        var aValue = a[sortProp];
        var bValue = b[sortProp];
        return sortValue(bValue, aValue);
      });
    default:
      return toSort;
  }
}
function applySortToValues(data, sortOrder) {
  var toSort = data.slice();
  switch (sortOrder) {
    case "asc":
      return toSort.sort(function (a, b) {
        return sortValue(a, b);
      });
    case "desc":
      return toSort.sort(function (a, b) {
        return sortValue(b, a);
      });
    default:
      return toSort;
  }
}